var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Search_2",
    d: "M20.5181 19.0317L17.1182 15.7077L17.0386 15.5865C16.8904 15.439 16.6878 15.3559 16.4763 15.3559C16.2649 15.3559 16.0623 15.439 15.9141 15.5865C13.0248 18.2373 8.57261 18.3814 5.51029 15.9232C2.44797 13.4651 1.72575 9.16748 3.82261 5.88059C5.91947 2.59369 10.1847 1.33743 13.7897 2.94497C17.3947 4.55251 19.2207 8.525 18.0567 12.2279C17.9729 12.4954 18.0414 12.7863 18.2365 12.9911C18.4315 13.1958 18.7235 13.2832 19.0023 13.2204C19.2812 13.1577 19.5046 12.9542 19.5884 12.6867C20.9798 8.29242 18.8784 3.56356 14.6435 1.5592C10.4087 -0.445164 5.31132 0.876502 2.64894 4.66921C-0.0134445 8.46192 0.558152 13.5875 3.99396 16.7301C7.42977 19.8728 12.6987 20.0894 16.3922 17.2399L19.4025 20.183C19.7134 20.4856 20.216 20.4856 20.5269 20.183C20.8375 19.8761 20.8375 19.3819 20.5269 19.075L20.5181 19.0317Z",
    fill: "#5E5E6B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.e31e9d05739d835f4dff6c90b9935d70.svg";
export { ForwardRef as ReactComponent };